import React from 'react';

import { Box, TextField, Button, Badge, CircularProgress } from '@mui/material';
import VideoSettingsIcon from '@mui/icons-material/VideoSettings';

export default function VEVoiceGenerator(props) {

    const [textChanged, setTextChanged] = React.useState(false);
    const [textDisabled, setTextDisabled] = React.useState(false);

    return (
        <>
            <TextField
                label="Text to speak"
                disabled={textDisabled}
                multiline
                maxRows={4}
                variant="standard"
                sx={{ width: '100%' }}
                value={props.value}
                onChange={(e) => {
                    setTextChanged(true);
                    props.updateProperty(e);
                }}
            />
            <p>{props.fieldDescription()}</p>
            <Box className="my-5 text-center">
                <Badge color="error" variant='dot' invisible={!textChanged}>
                    <Button variant='outlined' 
                        startIcon={
                            (!textDisabled) ? <VideoSettingsIcon /> : <CircularProgress size="1rem" />
                        } 
                        onClick={generateVoice} disabled={!textChanged}>
                        {
                            (!textDisabled) ? "Generate voice" : "Generating..."
                        }
                    </Button>
                </Badge>
            </Box>
        </>
    );


    async function generateVoice() {
        setTextChanged(false);
        setTextDisabled(true);

        const payload = {
            text: props.value,
            voice: props.element.voice ?? ""
        };

        console.log("Generate voice", props.value, props.element);

        fetch("https://api.json2video.com/v2/player", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        })
        .then((response) => {
            console.log(response);    
        })
        .catch((error) => {
            console.log(error);
        });
    }

}